module.exports = __webpack_public_path__ + "assets/Openbite.fe759e89f5da81498d577e54b6854161.png";